<template>
	<page>
		<v-row
			justify="center"
			align="center"
		>
			<v-col md="8">
				<v-card
					color="#092C58"
					height="400"
					class="text-center"
				>
					<v-card-text class="pt-5">
						<v-img
							width="500"
							src="/assets/ClapWay-dark.svg"
							class="mx-auto"
						/>
						<div class="white--text text-h1 mt-5">
							{{ statusCode }}
						</div>
						<div class="white--text text-h2 mt-5">
							{{ errorText }}
						</div>

						<div class="paragraph-text mt-2" />
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</page>
</template>

<script>
export default {
	name: "ErrorPage",
	props: {
		statusCode: { type: Number, default: 403 },
	},
	computed: {
		errorText () {
			return {
				403: "Authorize",
				404: "Page not found",
			}[this.statusCode] || "Something went wrong.";
		},
	},
	created () {

	},
};
</script>

<style scoped>

</style>
